import { useEffect, useSyncExternalStore } from 'react'

/**
 * A page that has steps of its own can take over the bar's Back for a while
 * (Huanrui, 2026-10-12: on the mood board, Back goes to choosing pictures,
 * not to the skills). While a page holds it, Back calls the page; once the
 * page lets go -- or leaves -- Back is a plain link again (TopNav.tsx).
 */

type Handler = () => void
let current: Handler | null = null
const listeners = new Set<() => void>()

function set(next: Handler | null) {
  current = next
  listeners.forEach((listener) => listener())
}

export function useBackHandler(): Handler | null {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    () => current,
  )
}

/** While `handler` is not null, the bar's Back calls it. */
export function useOverrideBack(handler: Handler | null) {
  useEffect(() => {
    if (!handler) return
    set(handler)
    return () => {
      if (current === handler) set(null)
    }
  }, [handler])
}
